import { useState, useCallback } from 'react';
import { MODALS } from '../constants';

const types = Object.keys(MODALS).reduce(
  (aggregate, key) => ({
    [MODALS[key]]: { show: false, data: {} },
    ...aggregate,
  }),
  {}
);

const useModal = () => {
  const [modals, setModals] = useState(types);

  const toggleModal = useCallback((type, show, data = {}) => {
    setModals(prevState => ({
      ...prevState,
      [`${type}`]: { show, data },
    }));
  }, []);

  const showModal = useCallback((type, data) => toggleModal(type, true, data), [
    toggleModal,
  ]);

  const hideModal = useCallback(
    (type, data) => toggleModal(type, false, data),
    [toggleModal]
  );

  return {
    showModal,
    hideModal,
    modals,
  };
};

export default useModal;
